// NOTE: Dependencies: jQuery, defiant, MarkerClusterer

(function ($) {
	$.fn.lmLocationMap = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			toggleBtn: '.map-toggle',
			details: '.location__details',
			toggleClass: 'location--details-hide',
			icon: {
				url: '/assets/images/map-icon.png',
				scaledSize: new google.maps.Size(60,75)
			},
			iconActive: {
				url: '/assets/images/map-icon-active.png',
				scaledSize: new google.maps.Size(80,100)
			},
			locationId: '',
			firstLoad: true,
			$body: $('body')
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			// Set URL
			$.fn.lmGlobal.checkPlatform(settings);

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$details = $context.parent();
			settings.location = $context.data('location-marker');
			settings.country = settings.$body.data('country');
			settings.fullDetailsLabel = settings.$body.data('full-details');
		}

		// Bind events
		methods.events = function($context) {
			
			// Click event for location close to toggle markers and close panel.
			$context.parent().find(settings.toggleBtn).off('click.lmLocationMap').on('click.lmLocationMap', function(event) {
				event.preventDefault();
				
				// Toggle googlemap markers and hide description panel.

				// functions for locations
				// If markers exist. Just toggle display. Else ajax call.
				if(settings.googleMapMarkers) {
					settings.$details.toggleClass(settings.toggleClass);
					methods.toggleMarkers($context);
					methods.checkZoom($context);
				} else {
					settings.$details.toggleClass(settings.toggleClass);
					methods.ajaxCheck($context);
				}
				
			});
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);
			settings.zoomLevel = $context.data('zoom');

			// Defaults set. And call set map function.
			settings.locationAreaLat = parseFloat($context.data('location-area').lat),
			settings.locationAreaLng = parseFloat($context.data('location-area').lng),
			methods.setMap($context);

		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Set map with custom silver JSON colour.
		methods.setMap = function($context) {

			settings.map = new google.maps.Map($context[0], {
				center: {
					lat: settings.locationAreaLat, 
					lng: settings.locationAreaLng
				},
				scrollwheel: false,
				zoom: settings.zoomLevel,
				zoomControl: true,
				styles: [
					{
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#f5f5f5"
							}
						]
					},
					{
						"elementType": "labels.icon",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#616161"
							}
						]
					},
					{
						"elementType": "labels.text.stroke",
						"stylers": [
							{
								"color": "#f5f5f5"
							}
						]
					},
					{
						"featureType": "administrative.land_parcel",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#bdbdbd"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#eeeeee"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#757575"
							}
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#e5e5e5"
							}
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#ffffff"
							}
						]
					},
					{
						"featureType": "road.arterial",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#757575"
							}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#dadada"
							}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#616161"
							}
						]
					},
					{
						"featureType": "road.local",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					},
					{
						"featureType": "transit.line",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#e5e5e5"
							}
						]
					},
					{
						"featureType": "transit.station",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#eeeeee"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#c9c9c9"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					}
				]
			});

			// Setting location marker

			settings.locationMarkerLat = parseFloat(settings.location.lat),
			settings.locationMarkerLng = parseFloat(settings.location.lng);
			settings.locationId = $context.data('location-id');
			methods.setCurrentLocation($context);

			// Idle event is once a zoom or pan event or page load of map is complete
			google.maps.event.addDomListener(settings.map, 'idle', function($context){
				
				// commenting out until happy with bug fix
				//settings.$details.removeClass('location--off-centre');
				settings.zoomLevel = settings.map.getZoom();
				
				if (typeof settings.googleMapMarkers !== 'undefined') {
					methods.checkZoom($context);
				}
			});

			// Resize map event
			google.maps.event.addDomListener(window, 'resize', function($context) {
				settings.$details.addClass('location--off-centre');

				var center = settings.map.getCenter();
				google.maps.event.trigger(settings.map, 'resize');
				settings.map.setCenter(center);

				// Reset markers and close panel if screen is mobile
				if ($(window).width() < 769 && settings.$details.hasClass(settings.toggleClass)) {
					settings.$details.toggleClass(settings.toggleClass);
					methods.toggleMarkers($context);
					methods.checkZoom($context);
				}
			});

		}

		// Set current location
		methods.setCurrentLocation = function($context) {
			var newGmapValue = new google.maps.LatLng(settings.locationMarkerLat, settings.locationMarkerLng),
					newGmapMarker = new google.maps.Marker({
						position: newGmapValue,
						map: settings.map,
						icon: settings.iconActive
					});

			// Click event for marker to reopen content panel
			google.maps.event.addListener(newGmapMarker, 'click', (function(newGmapMarker) {
				return function() {
					if (settings.$details.hasClass(settings.toggleClass)) {
						// Show content panel
						settings.$details.removeClass(settings.toggleClass);
						// Toggle rest of markers
						methods.toggleMarkers($context);
						methods.checkZoom($context);
					}
					// Re-centre map on click so focus is always on marker
					settings.map.setCenter(newGmapValue);

					// Add active marker and set rest to inactive
					for (var j = 0; j < settings.googleMapMarkers.length; j++) {
						settings.googleMapMarkers[j].setIcon(settings.icon);
					}
					this.setIcon(settings.iconActive);
				}
			})(newGmapMarker));

			// Setting as global var to access when clicking on other markers and details toggle
			settings.currentLocationMarker = newGmapMarker;
		}

		// Ajax Call
		methods.ajaxCheck = function($context) {
			// Check cache
			if (!settings.mapMarkers) {
				$.ajax({
					type: 'GET',
					dataType: 'json',
					url: settings.locationJsonUrl,
					success: function(data, textStatus, jqXHR) {
						settings.mapMarkers = data.Markers;
						settings.mapMessages = data.Messages;
						settings.dataSnapShot = defiant.getSnapshot(data);
						methods.setAllLocations($context);
					}
				});
			} else {
				// Cache
				methods.setAllLocations($context);
			}
		}

		methods.setAllLocations = function($context) {
			settings.googleMapMarkers = [];
			settings.googleMapInfoWindows = [];

			//setting info window
			var infoWindow = new google.maps.InfoWindow({
				maxWidth: 200
			});

			for (var i = 0; i < settings.mapMarkers.length; i++) {

				if (settings.locationId !== parseInt(settings.mapMarkers[i].Id)) {
					var newGmapValue = new google.maps.LatLng(settings.mapMarkers[i].Latitude, settings.mapMarkers[i].Longitude),
							newGmapMarker = new google.maps.Marker({
								position: newGmapValue,
								map: settings.map,
								icon: settings.icon
							}),
							contentString = `<div class="location__marker-content" data-marker="'${i}"><h2 class="heading-eyebrow heading-eyebrow--subtitle">${settings.mapMarkers[i].Name}</h2><div class="location__marker-address">${settings.mapMarkers[i].Address}</div><a href="tel:${settings.mapMarkers[i].phone}" class="location__marker-phone">${settings.mapMarkers[i].Phone}</a><a href="${settings.domain + settings.mapMarkers[i].Url}" class="button button--inverse-alt">${settings.fullDetailsLabel}</a></div>`;

					// Assign id so marker is searchable
					newGmapMarker.setValues({
						id: settings.mapMarkers[i].Id
					});

					// Assign contentString to click of marker to display infowindow
					google.maps.event.addListener(newGmapMarker, 'click', (function(newGmapMarker, contentString) {
						return function() {
							infoWindow.setContent(contentString);
							infoWindow.open(settings.map, newGmapMarker);

							// Add active marker and set rest to inactive
							for (var j = 0; j < settings.googleMapMarkers.length; j++) {
								settings.googleMapMarkers[j].setIcon(settings.icon);
							}

							this.setIcon(settings.iconActive);
							settings.currentLocationMarker.setIcon(settings.icon);

						}
					})(newGmapMarker, contentString));

					// Pushing markers and infowindow to arrays so can toggle show / hide effectively
					settings.googleMapMarkers.push(newGmapMarker);
					settings.googleMapInfoWindows.push(infoWindow);
				}
			}
		}

		methods.checkZoom = function($context) {

			if (settings.zoomLevel > 8 && settings.$details.hasClass(settings.toggleClass)) {
				for (var i = 0; i < settings.googleMapMarkers.length; i++) {
					if(!settings.googleMapMarkers[i].getVisible()) {
						settings.googleMapMarkers[i].setVisible(true);
					}
				}
			} else {
				for (var i = 0; i < settings.googleMapMarkers.length; i++) {
					if(settings.googleMapMarkers[i].getVisible()) {
						settings.googleMapMarkers[i].setVisible(false);
					}
				}
			}
		}

		methods.toggleMarkers = function($context) {

			// Toggle Markers
			for (var i = 0; i < settings.googleMapMarkers.length; i++) {
				if(settings.googleMapMarkers[i].getVisible()) {

					// Add active marker and set rest to inactive
					settings.googleMapMarkers[i].setIcon(settings.icon);
					settings.googleMapMarkers[i].setVisible(false);
					settings.currentLocationMarker.setIcon(settings.iconActive);
				}
				else {
					settings.googleMapMarkers[i].setVisible(true);
				}
			}
			// Toggle InfoWindows
			for (var i=0; i < settings.googleMapInfoWindows.length; i++) {
				settings.googleMapInfoWindows[i].close();
			}
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	if($('.location__map').length) {
		$('.location__map').lmLocationMap();
	}

}(jQuery));